import { render, staticRenderFns } from "./DisciplineCategorySimpleView.vue?vue&type=template&id=35c1ccab&"
import script from "./DisciplineCategorySimpleView.vue?vue&type=script&lang=js&"
export * from "./DisciplineCategorySimpleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports